// packages
import 'intersection-observer';
import yall from 'yall-js';
import debounce from 'lodash.debounce';

// local imports
import { AdLoader } from './ads/loader';
import { boot as bootFireLookoutArt } from './fire-lookout-art';
import { boot as bootNav } from './nav';
import './hover';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);
bootNav();

var asciiArt;
var asciiImg;

let observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.intersectionRatio > 0) {
      asciiArt = entry.target.querySelector('.ascii-art');
      asciiArt.classList.add('ascii-ani');

      asciiImg = entry.target.querySelector('.ascii-img');
      asciiImg.classList.add('img-ani');
    }
  });
});

const images = document.querySelectorAll('.ascii-container');
images.forEach((image) => {
  observer.observe(image);
});

bootFireLookoutArt();
window.addEventListener('resize', () => {
  bootFireLookoutArt();
});
